import toast from "react-hot-toast";
import { CalendarArrowUp, CalendarArrowDown } from "lucide-react";
import { addOrderPickupToCalendar, addOrderDeliveryToCalendar } from "../../utils/calendar";
import { isNativeApp } from "../../utils/nativeNavigation";

// Visibile solo su app nativa: su web (desktop e mobile) la scrittura sul
// calendario di sistema non è disponibile, quindi il pulsante non deve
// nemmeno comparire (e con lui il contenitore, per non lasciare spazi vuoti).
export default function AddToCalendarButtons({
    order,
    actor = "customer",
    disabled = false,
    containerClassName = "order-calendar-actions",
}) {
    if (!isNativeApp()) return null;

    async function handleAddPickupToCalendar() {
        try {
            await addOrderPickupToCalendar(order, { actor });
            toast.success("Ritiro aggiunto al calendario");
        } catch (err) {
            toast.error(err?.message || "Impossibile aggiungere il ritiro al calendario");
        }
    }

    async function handleAddDeliveryToCalendar() {
        try {
            await addOrderDeliveryToCalendar(order, { actor });
            toast.success("Consegna aggiunta al calendario");
        } catch (err) {
            toast.error(err?.message || "Impossibile aggiungere la consegna al calendario");
        }
    }

    return (
        <div className={containerClassName}>
            <button
                type="button"
                className="btn btn-ghost btn-icon btn-icon--touch"
                onClick={handleAddPickupToCalendar}
                disabled={disabled || !order?.data_ritiro}
                aria-label="Aggiungi ritiro al calendario"
                title="Aggiungi ritiro al calendario"
            >
                <CalendarArrowUp size={18} aria-hidden="true" />
            </button>

            <button
                type="button"
                className="btn btn-ghost btn-icon btn-icon--touch"
                onClick={handleAddDeliveryToCalendar}
                disabled={disabled || !order?.data_consegna}
                aria-label="Aggiungi consegna al calendario"
                title="Aggiungi consegna al calendario"
            >
                <CalendarArrowDown size={18} aria-hidden="true" />
            </button>
        </div>
    );
}
